export default [

     {
          path: '/third-party-assessment-answer/:id',
          name: 'ThirdPartyAssessmentAnswer',
          component: () => import("@/views/Page/ThirdPartyAssessmentAnswer/ThirdPartyAssessmentAnswer.vue"),
           meta: {
               title: 'Questionnaire Result',
               requiresAuth: false 
          },
     }
];